document.addEventListener('alpine:init', () => {
    window.Alpine.data('articleBeforeAfter', (config) => ({
        init() {
            let beforeElement = document.querySelector('.article-before');
            let afterElement = document.querySelector('.article-after');
            if (beforeElement && afterElement) {
                let beforeElementLink = beforeElement.querySelector('a');
                let afterElementLink = afterElement.querySelector('a');
                if (afterElementLink.clientHeight > beforeElementLink.clientHeight) {
                    beforeElementLink.style.height = afterElementLink.clientHeight + 'px';
                } else {
                    afterElementLink.style.height = beforeElementLink.clientHeight + 'px';
                }
            }
        },
    }));
});
